import { Outlet } from 'react-router-dom';
import { Toaster } from 'sonner';

import AppLayout from '@/components/AppLayout/AppLayout';
import AppLoader from '@/components/AppLoader/AppLoader';
import useAppInitialization from '@/hooks/useAppInitialization';

export default function App() {
  const { isReady, error, tasks, retry } = useAppInitialization();

  if (!isReady) {
    return <AppLoader tasks={tasks} error={error} onRetry={retry} />;
  }

  return (
    <>
      <AppLayout>
        <Outlet />
      </AppLayout>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          className: 'bg-slate border-storm text-pearl',
        }}
      />
    </>
  );
}
